<template>
  <div class="m-nav__dropdown" @mouseleave="close">
    <component :is="url ? 'a' : 'button'" :href="url ? url : null" class="m-nav__dropdown-toggle" :class="{ 'is-active': isOpen }" @mouseenter="open" v-on:[touchEvent].passive="open" @keydown.enter.prevent="toggle" @keydown.esc.prevent="close" :aria-expanded="isOpen ? 'true' : 'false'">
      <span class="m-nav__dropdown-label" v-text="title"></span>
      <svg class="m-nav__dropdown-icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#btn-arrow-down'" />
      </svg>
    </component>
    <transition>
      <div v-if="isOpen" class="m-nav__dropdown-content">
        <a v-if="url" class="u-skip-link" :href="url">{{ $t('navigate_to') }} {{ title }}</a>
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      url: {
        type: String,
        default: null,
      },
    },

    data: () => ({
      isOpen: false,
      touchEvent: "touchstart",
    }),

    mounted() {
      document.addEventListener("touchstart", this.handleEventOutside, { passive: true });
      document.addEventListener("focusin", this.handleEventOutside);
    },

    unmounted() {
      document.removeEventListener("touchstart", this.handleEventOutside, { passive: true });
      document.removeEventListener("focusin", this.handleEventOutside);
    },

    methods: {
      open() {
        this.isOpen = true;
        this.touchEvent = null;
      },

      close() {
        this.isOpen = false;
        this.touchEvent = "touchstart";
      },

      toggle() {
        this.isOpen ? this.close() : this.open();
      },

      handleEventOutside(e) {
        if (!this.$el.contains(e.target)) {
          this.close();
        }
      },
    },
  }
</script>
